<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span class="title dialog-title" i18n>Элементы и материалы</span>

      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <mat-tab-group class="flex-1 h-full w-full min-h-full min-w-full" mat-stretch-tabs>
      <mat-tab i18-label label="Элементы" i18n-label>
        <table class="w-full" mat-table #table [dataSource]="dataSource" fusePerfectScrollbar>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef i18n>Название</th>
            <td mat-cell *matCellDef="let item">{{ item.name }}</td>
          </ng-container>

          <ng-container matColumnDef="materialName">
            <th mat-header-cell *matHeaderCellDef i18n>Материал</th>
            <td mat-cell *matCellDef="let item">{{ formatMaterialName(item.materialName) }}</td>
          </ng-container>

          <ng-container matColumnDef="article">
            <th mat-header-cell *matHeaderCellDef i18n>Артикул</th>
            <td mat-cell *matCellDef="let item">
              {{ item.article }}
            </td>
          </ng-container>

          <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef i18n>Количество</th>
            <td mat-cell *matCellDef="let item">
              {{ item.count }}
            </td>
          </ng-container>

          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef i18n>Цена</th>
            <td mat-cell *matCellDef="let item">
              {{ item.price }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </mat-tab>

      <mat-tab i18n-label label="Материалы" *ngIf="productProcessingMode !== 0">
        <cutting-product-materials-link-info [productMaterialLink]="productMaterialLink">
        </cutting-product-materials-link-info>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
